import { GlobalResponseObject } from "@gtpl/shared-models/common-models"
import { WorkCalenderDto } from "./work-calender.dto";


export class WorkCalenderResponse extends GlobalResponseObject{
    data?:WorkCalenderDto[]

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */

    constructor(status:boolean, intlCode:number, internalMessage:string, data?: WorkCalenderDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}